import { Box, Button, chakra, Flex, Text } from '@chakra-ui/react';
import useOrderListItemInfoRows from 'hooks/modules/order/useOrderListItemInfoRows';
import useOrderTimeLabel from 'hooks/modules/order/useOrderTimeLabel';
import useAppTheme from 'hooks/shared/useAppTheme';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  orderData: OrderListItem;
  onDetailClick: () => void;
}

const OrdersGridItem: FC<Props> = ({
  orderData: order,
  onDetailClick,
  ...props
}) => {
  const { t } = useTranslation();

  const orderTimeLabel = useOrderTimeLabel();

  const getInfoRows = useOrderListItemInfoRows();
  const infoRows = getInfoRows(order);

  const theme = useAppTheme();
  const statusColor = order.status.color ?? theme.colors[Color.Primary500];

  return (
    <AppCard
      w="calc(50% - 10px)"
      boxShadow={
        order.status.isHighlighted ? `0 0 0 5px ${statusColor}` : 'unset'
      }
      display="flex"
      flexDirection="column"
      {...props}
    >
      <Flex
        borderTopRadius="15px"
        justifyContent="space-between"
        px="20px"
        py="10px"
        bgColor={statusColor}
        h="100px"
      >
        <Text
          alignSelf="flex-end"
          noOfLines={2}
          fontSize={30}
          color="#fff"
          fontWeight={700}
        >
          {order.name}
        </Text>
        <Text
          noOfLines={1}
          textAlign="right"
          minW="60px"
          fontSize={24}
          color="#fff"
          fontWeight={700}
        >
          {orderTimeLabel(order.createdAt)}
        </Text>
      </Flex>
      <Flex
        p="15px"
        flex="1"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box mb="15px">
          {infoRows.map((row, index) => {
            return (
              <CardInfoRow key={index} label={row.label}>
                <Text
                  color={
                    row.fieldId === 'status' ? Color.Primary500 : undefined
                  }
                >
                  {row.value}
                </Text>
              </CardInfoRow>
            );
          })}
        </Box>
        <Button onClick={onDetailClick} w="full">
          {t('moreDetails')}
        </Button>
      </Flex>
    </AppCard>
  );
};

export default chakra(OrdersGridItem);
